import { useEffect, useState } from "react";
import { FormRow, SubmitBtn } from "../components";
import Wrapper from "../assets/wrappers/DashboardFormPage";
import { Form, redirect, useParams, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { customFetch } from "../utils/custom-fetch.js";
import Switch from "@mui/material/Switch";

export const action = async ({ request, params }) => {
  const form = await request.formData();
  const { campaignId } = params;

  const mediaFile = form.get("mediaFile"); // רק אם קובץ נבחר

  const data = {
    name: form.get("name"),
    startDate: form.get("startDate"),
    endDate: form.get("endDate"),
    startTime: form.get("startTime"),
    endTime: form.get("endTime"),
    isGlobal: form.get("isGlobal") === "on" || form.get("isGlobal") === "true",
    workOnSaturday: form.get("workOnSaturday") === "on",
  };

  const builtFormData = new FormData();

  for (const key in data) {
    builtFormData.append(key, data[key]);
  }

  if (mediaFile && mediaFile.size > 0) {
    builtFormData.append("mediaFile", mediaFile);
  }
  
  try {
    if (campaignId) {
      await customFetch.patch(`/campaigns/${campaignId}`, builtFormData);
      toast.success("הקמפיין עודכן בהצלחה");
    } else {
      await customFetch.post("campaigns", builtFormData);
      toast.success("הבקשה נשלחה בהצלחה והיא מחכה לאישור");
    }
    return redirect("/dashboard");
  } catch (error) {
    toast.error(error?.response?.data?.msg || "שגיאה בעדכון הקמפיין");
    return redirect("/dashboard");
    // return null;
  }
};

const validateAndCropImage = (file, setFormData) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (event) => {
    const img = new Image();
    img.src = event.target.result;
    img.onload = () => {
      const { width, height } = img;
      const aspectRatio = width / height;
      const targetRatio = 16 / 9;

      if (Math.abs(aspectRatio - targetRatio) < 0.01) {
        setFormData((prev) => ({ ...prev, mediaFile: file }));
        return;
      }

      const userConfirmed = window.confirm(
        "התמונה אינה ביחס 16:9. האם תרצה שנחתוך אותה אוטומטית?"
      );

      if (!userConfirmed) {
        toast.error("העלאת התמונה בוטלה. יש להעלות תמונה ביחס 16:9.");
        return;
      }

      const canvas = document.createElement("canvas");
      let newWidth, newHeight, offsetX, offsetY;

      if (aspectRatio > targetRatio) {
        newWidth = height * targetRatio;
        newHeight = height;
        offsetX = (width - newWidth) / 2;
        offsetY = 0;
      } else {
        newWidth = width;
        newHeight = width / targetRatio;
        offsetX = 0;
        offsetY = (height - newHeight) / 2;
      }

      canvas.width = 1920;
      canvas.height = 1080;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        img,
        offsetX,
        offsetY,
        newWidth,
        newHeight,
        0,
        0,
        1920,
        1080
      );

      canvas.toBlob((blob) => {
        const croppedFile = new File([blob], file.name, { type: file.type });
        setFormData((prev) => ({ ...prev, mediaFile: croppedFile }));
        toast.success("התמונה נחתכה ונשמרה בהצלחה!");
      }, file.type);
    };
  };
};

const AdvertiserRequest = () => {
  const { campaignId } = useParams();
  const isEdit = Boolean(campaignId);
  const today = new Date().toISOString().split("T")[0];
  const { user } = useOutletContext();
  const [formData, setFormData] = useState({
    name: "",
    mediaFile: null,
    startDate: today,
    endDate: "",
    startTime: "00:00",
    endTime: "23:59",
    isGlobal: false,
    workOnSaturday: false,
  });

  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const { data } = await customFetch.get(`/campaigns/${campaignId}`);

        const campaign = data.campaign;

        setFormData({
          name: campaign.name || "",
          mediaFile: null,
          startDate: campaign.startDate?.slice(0, 10) || today,
          endDate: campaign.endDate?.slice(0, 10) || "",
          startTime: campaign.displayHours?.start || "00:00",
          endTime: campaign.displayHours?.end || "23:59",
          isGlobal: campaign.isGlobal ?? false,
          workOnSaturday: !!campaign.workOnSaturday,
        });

        setImagePreview(campaign.media?.[0]?.url || "");
      } catch {
        toast.error("שגיאה בטעינת נתוני הקמפיין לעריכה");
      }
    };

    if (isEdit) fetchCampaign();
  }, [campaignId]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) validateAndCropImage(file, setFormData);
  };

  return (
    <Wrapper className="full-page">
      <Form method="post" className="form" encType="multipart/form-data">
        {imagePreview && (
          <div className="form-row">
            <label className="form-label">תמונה נוכחית</label>
            <img
              src={imagePreview}
              alt="preview"
              className="img"
              style={{ maxHeight: "300px", maxWidth: "300px" }}
            />
          </div>
        )}
        <h4 className="form-title">
          {isEdit ? "עריכת קמפיין" : "בקשה לקמפיין פרסום"}
        </h4>
        <div className="form-center">
          {!isEdit && (
            <div className="form-row">
              <label htmlFor="mediaFile" className="form-label">
                בחר קובץ מדיה (גודל מקסימלי 15MB, יחס 16:9)
              </label>
              <input
                type="file"
                id="mediaFile"
                name="mediaFile"
                className="form-input"
                accept="image/*,video/*"
                onChange={handleFileChange}
              />
            </div>
          )}

          <FormRow
            type="text"
            name="name"
            labelText="שם הקמפיין"
            value={formData.name}
            defaultValue={formData.name}
            handleChange={(e) =>
              setFormData((prev) => ({ ...prev, name: e.target.value }))
            }
          />
          <FormRow
            type="date"
            name="startDate"
            labelText="תאריך תחילת הקמפיין"
            value={formData.startDate}
            defaultValue={formData.startDate}
            handleChange={(e) =>
              setFormData((prev) => ({ ...prev, startDate: e.target.value }))
            }
          />
          <FormRow
            type="date"
            name="endDate"
            labelText="תאריך סיום הקמפיין"
            value={formData.endDate}
            defaultValue={formData.endDate}
            handleChange={(e) =>
              setFormData((prev) => ({ ...prev, endDate: e.target.value }))
            }
          />
          <FormRow
            type="time"
            name="startTime"
            labelText="שעת תצוגה התחלתית"
            value={formData.startTime}
            defaultValue={formData.startTime}
            handleChange={(e) =>
              setFormData((prev) => ({ ...prev, startTime: e.target.value }))
            }
          />
          <FormRow
            type="time"
            name="endTime"
            labelText="שעת תצוגה סופית"
            value={formData.endTime}
            defaultValue={formData.endTime}
            handleChange={(e) =>
              setFormData((prev) => ({ ...prev, endTime: e.target.value }))
            }
          />

          <div className="form-row">
            <label htmlFor="workOnSaturday" className="form-label">
              הצג בשבת
            </label>
            <Switch
              name="workOnSaturday"
              checked={formData.workOnSaturday}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  workOnSaturday: e.target.checked,
                }))
              }
            />
          </div>

          {user?.role === "admin" && (
            <div className="form-row">
              <label htmlFor="isGlobal" className="form-label">
                פרסמו לי בכל המסכים
              </label>
              <Switch
                name="isGlobal"
                checked={!!formData.isGlobal}
                defaultValue={formData.isGlobal}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    isGlobal: e.target.checked,
                  }))
                }
              />
            </div>
          )}

          <div className="btn-container">
            <SubmitBtn formBtn buttonText={isEdit ? "עדכון" : "שמירה"} />
            <button
              className="btn btn-block clear-btn"
              onClick={(e) => {
                e.preventDefault();
                setFormData({
                  name: "",
                  mediaFile: null,
                  startDate: today,
                  endDate: "",
                  startTime: "00:00",
                  endTime: "23:59",
                  isGlobal: false,
                });
                setImagePreview("");
              }}
            >
              ניקוי שדות
            </button>
          </div>
        </div>
      </Form>
    </Wrapper>
  );
};

export default AdvertiserRequest;
